import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import News from "./components/News";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ServicesPage from "./components/ServicesPage";
import CustomersPage from "./components/CustomersPage";
import { Toaster } from "./components/ui/toaster";

const Home = () => {
  return (
    <div className="App bg-background">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <News />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/palvelut" element={<ServicesPage />} />
        <Route path="/asiakkaat" element={<CustomersPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
